const RedirectService = (url) => {
    window.location.href = url;
}

export default RedirectService;